import { BaSeLoading } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

const ForbiddenPage: React.FC = () => {
  const { isAuthenticated, login } = Sebrae.useAuth();

  React.useEffect(() => {
    if (!isAuthenticated) {
      login();
      return;
    }
  }, [isAuthenticated, login]);

  return <BaSeLoading text="Carregando…" />;
};

export { ForbiddenPage as default };
